export const CAROUSEL_ITEM = 'carouselItem'
export default CAROUSEL_ITEM
